// extracted by mini-css-extract-plugin
export default {"sliderDiv":"Slider_sliderDiv__+KzNU","slide":"Slider_slide__7fbrL","slideActive":"Slider_slideActive__ZZa1r","slideSpacer":"Slider_slideSpacer__zNY04"};